import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import MainLayout from '@/components/MainLayout'
import Callback from '@/components/Callback'
import Logout from '@/components/Logout'
import Heartbeat from '@/components/Heartbeat'
import mainStore from '@/store/main/main-store'
import feedStore from '@/store/feed/feed-store'

Vue.use(VueRouter)
Vue.use(Meta)

let appRouter = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: MainLayout,
      beforeEnter: homePage
    },
    {
      path: '/statements',
      name: 'statements',
      component: MainLayout,
      beforeEnter: statementsPage
    },
    {
      path: '/convos',
      name: 'convos',
      component: MainLayout,
      beforeEnter: convosPage
    },
    {
      path: '/about',
      name: 'about',
      component: MainLayout,
      beforeEnter: aboutPage
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: MainLayout,
      beforeEnter: feedbackPage
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/heartbeat',
      name: 'heartbeat',
      component: Heartbeat
    },
    
    // {
      // path: '/about',
      // name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
//      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },

  ],
})

function aboutPage(req : any, res : any, next : any) {
  mainStore.dispatchSetCurrentPage({component: 'about', page: 'about', isAuthRequired: false, forceLogin: false})
  next()
}

function homePage(req : any, res : any, next : any) {
  feedStore.dispatchSetFeedPage({feedType: 'statement-feed', page: 'statements', forceLogin: false, id: req.query.id, uid: req.query.uid}).then(() => {
    next()
  })
}

function statementsPage(req : any, res : any, next : any) {
  console.log('Router: Handling statements route')
  feedStore.dispatchSetFeedPage({feedType: 'statement-feed', page: 'statements', forceLogin: false, id: req.query.id, uid: req.query.uid}).then(() => {
    next()
  })
}

function convosPage(req : any, res : any, next : any) {
  feedStore.dispatchSetFeedPage({feedType: 'convo-feed', page: 'convos', forceLogin: false, id: req.query.id, uid: req.query.uid}).then(() => {
    next()
  })
}

function feedbackPage(req : any, res : any, next : any) {
  mainStore.dispatchSetCurrentPage({component: 'feedback', page: 'feedback', isAuthRequired: false, forceLogin: false})
  next()
}

export default appRouter